export const convertToTons = (cubicMeters: number) => {
  var tons = cubicMeters * 1.7;
  return tons;
}

export const convertToCubicMeters = (tons: number) => {
  var cubicMeters = tons / 1.7;
  return cubicMeters;
}